import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { BrowserRouter } from 'react-router-dom';
import 'axios-progress-bar/dist/nprogress.css';
import { loadProgressBar } from 'axios-progress-bar';

import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';
import { fetchProfile,  addProfile } from './actions/profile_action';
import { addLogin } from './actions/loggedin_action';

import { API_URL } from './config/urls';

window.URL = API_URL.ADMIN_API;

const store = createStore(rootReducer, compose(applyMiddleware(thunk)));

if(localStorage.token) {    
    let profileCheck = JSON.parse(localStorage.getItem('profile'))
    if(!localStorage.profile || Array.isArray(profileCheck)){
        store.dispatch(fetchProfile());   
    }   
    store.dispatch(addLogin(true));
} else {
    store.dispatch(addLogin(false));
}

if (localStorage.profile) {
    store.dispatch(addProfile(JSON.parse(localStorage.profile)))
}


// loadProgressBar();

//window.URL = "https://console.terravirtua.io/"

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
